import RadioButtonGroup from '@/common/ant-components/RadioGroupReport';
import { periodArrayEnglish } from '@/common/custom-date-selector/helpers';
import useAppData from '@/hooks/useAppData';
import { getTodayDateAd } from '@/utils/helpers/getTodayDate';
import {
  Button,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Popover,
} from 'antd';
import { disableDateBetween, userData } from '../helpers';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';
import { CalendarOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { AntButton } from '@/common/ant-components/AntButton';

interface Props {
  radioButtonProps: {
    onChange: (e: any) => void;
    initialValue: any;
    name: string;
  };
  dateType: string;
  customDateSelectorPropsEnglish: {
    periodValueList: any;
    setPeriodValueList: (data: any) => void;
    periodValue: string;
    setPeriodValue?: (data: string) => void;
    dateType: string;
    setDateType: (data: string) => void;
    setStartDate: (data: string) => void;
    setEndDate: (data: string) => void;
    setSalesStartDate: (data: any) => void;
    setSalesEndDate: (data: any) => void;
    selectedPeriodList: any;
    setSelectedPeriodList: (data: any) => void;
  };
}

const DateChangeWithPopOverEnglish: React.FC<Props> = (props) => {
  const { radioButtonProps, dateType, customDateSelectorPropsEnglish } = props;
  const { onChange, initialValue, name } = radioButtonProps;

  const [open, setPopOverOpen] = useState(false);
  const {
    periodValueList,
    setPeriodValueList,
    setEndDate,
    setStartDate,
    setSalesStartDate,
    setSalesEndDate,
    selectedPeriodList,
    setSelectedPeriodList,
  } = customDateSelectorPropsEnglish;
  const form = Form.useFormInstance();
  const selectedPeriod = Form.useWatch('period', form);

  const { pathname } = useLocation();

  const { app } = useAppData();
  const isActive = app?.isActive;

  const customDate = [
    {
      label: 'Custom',
      value: 'Custom',
      from: {
        date: isActive ? getTodayDateAd() : app?.financialStartYear,
      },
      to: {
        date: isActive ? getTodayDateAd() : app?.financialEndYear,
      },
    },
  ];

  const allDate = {
    label: 'All',
    value: 'All',
    from: {
      date: app?.financialStartYear,
      dateTime: `${app?.financialStartYear}T00:00:00.000Z`,
    },
    to: {
      date: app?.financialEndYear,
      dateTime: `${app?.financialEndYear}T00:00:00.000Z`,
    },
  };

  const optionsArray = isActive
    ? [
        ...periodArrayEnglish.map((item: any) => ({
          label: item.label,
          value: item.label,
          from: item.value.from,
          to: item.value.to,
        })),
        allDate,
        // ...customDate,
      ]
    : [allDate];

  const onChangeEnglishDate = (text: string, option: any) => {
    form.setFieldValue('period', text);
    setPeriodValueList &&
      setPeriodValueList({
        ...periodValueList,
        [pathname]: text,
      });
    setStartDate && setStartDate(option?.from?.date);

    setSelectedPeriodList &&
      setSelectedPeriodList({
        ...selectedPeriodList,
        [pathname]: text ?? option?.label,
      });

    setSalesStartDate &&
      setSalesStartDate((prev: any) => ({
        ...prev,
        [pathname]: option?.from?.date,
      }));

    setEndDate && setEndDate(option?.to?.date);

    setSalesEndDate &&
      setSalesEndDate((prev: any) => ({
        ...prev,
        [pathname]: option?.to?.date,
      }));
    if (option?.value !== 'Custom') {
      form.setFieldsValue({
        from_ad: dayjs(option?.from?.date) || '',
        to_ad: dayjs(option?.to?.date) || '',
        from_ad_dummy: option?.from?.date,
        to_ad_dummy: option?.to?.date,
      });
    } else {
      form.setFieldsValue({
        from: dayjs(app?.financialStartYear || getTodayDateAd()),
        to: dayjs(app?.financialEndYear || getTodayDateAd()),
        from_ad_dummy: app?.financialStartYear || option?.from?.date,
        to_ad_dummy: app?.financialEndYear || option?.to?.date,
      });
    }
  };

  const renderContent = (
    <div>
      {dateType === 'ad' ? (
        <>
          <Form.Item
            name="period"
            noStyle
            hidden
            initialValue={
              isActive
                ? periodValueList?.[pathname] || periodValueList?.defaultPeriod
                : 'All'
            }
          ></Form.Item>
          <Form.Item hidden name={'from_ad_dummy'}></Form.Item>
          <Form.Item hidden name={'to_ad_dummy'}></Form.Item>
          <Divider
            style={{
              padding: 0,
              margin: '10px 0',
            }}
          />
          <div className="tw-grid tw-grid-cols-2 tw-gap-1">
            {optionsArray.map((option) => (
              // <Button
              //   key={option.value}
              //   type={selectedPeriod === option.value ? 'primary' : 'default'}
              //   onClick={() => onChangeEnglishDate(option.value, option)}
              // >
              //   {option.label}
              // </Button>

              <Button
                key={option.value}
                // type="default"
                // type="dashed"
                // color="default"
                type={selectedPeriod === option.value ? undefined : 'dashed'}
                color="default"
                variant="outlined"
                // variant="solid"
                // onClick={() => handleOptionClick(option)}
                onClick={() => {
                  onChangeEnglishDate(option.value, option);
                  setPopOverOpen(false);
                }}
                // block
              >
                {option.label}
              </Button>
            ))}
          </div>
          <Divider
            style={{
              padding: 0,
              margin: '10px 0',
            }}
          />

          <div className="tw-grid tw-grid-cols-2 tw-gap-1">
            <div></div>
            <div className="tw-flex tw-justify-end tw-w-full">
              <RadioButtonGroup
                name={name}
                initialValue={initialValue}
                onChange={onChange}
              />
            </div>
          </div>
          <Form.Item
            shouldUpdate={(prevValues, curValues) =>
              prevValues.from_ad !== curValues.from_ad ||
              prevValues.to_ad !== curValues.to_ad ||
              prevValues.from_ad_dummy !== curValues.from_ad_dummy ||
              prevValues.to_ad_dummy !== curValues.to_ad_dummy
            }
            noStyle
          >
            {({ getFieldsValue }) => {
              const { from_ad_dummy, to_ad_dummy } = getFieldsValue();
              return (
                <>
                  <div className="md:tw-grid md:tw-grid-cols-2 tw-gap-x-2">
                    <div>
                      <Form.Item
                        name="from_ad"
                        label="Custom"
                        layout="vertical"
                      >
                        <DatePicker
                          style={{
                            width: '100%',
                          }}
                          onChange={(_: any, date: any) => {
                            if (date) {
                              form.setFieldsValue({
                                from_ad_dummy: date,
                              });
                            }
                          }}
                          disabledDate={disableDateBetween(
                            app?.financialStartYear,
                            to_ad_dummy || app?.financialEndYear,
                          )}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                    </div>

                    <div>
                      <Form.Item name="to_ad" layout="vertical" label=" ">
                        <DatePicker
                          style={{
                            width: '100%',
                          }}
                          onChange={(_: any, date: any) => {
                            if (date) {
                              form.setFieldsValue({
                                to_ad_dummy: date,
                              });
                            }
                          }}
                          format="YYYY-MM-DD"
                          disabledDate={disableDateBetween(
                            from_ad_dummy || app?.financialStartYear,
                            app?.financialEndYear,
                          )}
                          //   disabled={selectedPeriod !== 'Custom'}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </>
              );
            }}
          </Form.Item>

          <Divider
            style={{
              padding: 0,
              margin: '10px 0',
            }}
          />
          <div className="tw-flex tw-justify-end">
            <Button
              onClick={() => {
                onChangeEnglishDate('Custom', {
                  label: 'Custom',
                  from: {
                    date: form.getFieldValue('from_ad')
                      ? dayjs(form.getFieldValue('from_ad')).format(
                          'YYYY-MM-DD',
                        )
                      : getTodayDateAd(),
                  },
                  to: {
                    date: form.getFieldValue('to_ad')
                      ? dayjs(form.getFieldValue('to_ad')).format('YYYY-MM-DD')
                      : getTodayDateAd(),
                  },
                });
                setPopOverOpen(false);
              }}
            >
              Apply
            </Button>
          </div>
        </>
      ) : (
        ''
      )}
    </div>
  );

  const modifiledPeriodArray = [
    ...periodArrayEnglish,
    {
      label: 'All',
      value: {
        from: (() => {
          return {
            date: app?.financialStartYear,
            dateTime: `${app?.financialStartYear}T00:00:00.000Z`,
          };
        })(),
        to: (() => {
          return {
            date: app?.financialEndYear,
            dateTime: `${app?.financialEndYear}T00:00:00.000Z`,
          };
        })(),
      },
    },
  ];

  useEffect(() => {
    if (selectedPeriod) {
      const periodObject = [...modifiledPeriodArray]?.find(
        (p) => p?.label?.toLowerCase() === selectedPeriod?.toLowerCase(),
      )?.value;

      form.setFieldsValue({
        from_ad: dayjs(periodObject?.from?.date || app?.financialStartYear),
        to_ad: dayjs(periodObject?.to?.date || app?.financialEndYear),
        from_ad_dummy: periodObject?.from?.date || app?.financialStartYear,
        to_ad_dummy: periodObject?.to?.date || app?.financialEndYear,
      });
    }
  }, [dateType, selectedPeriod]);

  return (
    <Popover
      open={open}
      onOpenChange={(visible) => setPopOverOpen(visible)}
      content={renderContent}
      placement="bottomLeft"
      title={
        <div
          style={{
            padding: '8px 0',
          }}
        >
          Date Filter
        </div>
      }
      trigger="click"
    >
      <AntButton
        // variant="outlined"
        // type={'dashed'}
        color="green"
        icon={<CalendarOutlined className="tw-text-[0.95rem] tw-ms-1" />}
        iconPosition="end"
        onClick={() => setPopOverOpen(!open)}
      >
        {selectedPeriodList?.[pathname] || selectedPeriod || 'Today'}
      </AntButton>
    </Popover>
  );
};
export default DateChangeWithPopOverEnglish;
